<script>
export default {
  name: "EmailIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  }
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none" role="img" aria-label="Ícone de email">
    <title>Ícone de email</title>
    <path
      d="M14.6001 1.99998C14.6001 1.22998 13.9701 0.599976 13.2001 0.599976H2.0001C1.2301 0.599976 0.600098 1.22998 0.600098 1.99998M14.6001 1.99998V10.4C14.6001 11.17 13.9701 11.8 13.2001 11.8H2.0001C1.2301 11.8 0.600098 11.17 0.600098 10.4V1.99998M14.6001 1.99998L7.6001 6.89998L0.600098 1.99998"
      :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>